/*
A BACK HI HA LA MATEIXA ENUM AMB EQUIVALENCIA DE fitlerKey
*/
export enum BookingFilterStatus {

    NoFiltersStatus = 'ROUTE.FILTER.NOFILTERSSTATUS',

	Alive = 'BOOKING.FILTER.ALIVE',

	Promised = 'BOOKING.FILTER.PROMISED',

	Inprogress = 'BOOKING.FILTER.INPROGRESS',

	Done = 'BOOKING.FILTER.DONE',

	Canceled = 'BOOKING.FILTER.CANCELED',

	None = 'NONE'
    
}